import { Stack } from '@mui/material';
import { Typography } from '@upheal/design-system/components/Typography/Typography';
import { Chip } from '@upheal/design-system/components/Chip/Chip';
import { PricingTier } from '@upheal/billing/utils/plans';

const tierColorMap = {
    [PricingTier.STARTER]: 'ds.fg.accent1.primary',
    [PricingTier.PREMIUM]: 'ds.fg.accent2.primary',
} as const;

type PricingCardTitleProps = {
    children: React.ReactNode;
    tier?: PricingTier;
    isPopular?: boolean;
    isDimmed?: boolean;
};
export const PricingCardTitle = (props: PricingCardTitleProps) => {
    const { children, tier, isPopular, isDimmed } = props;

    const getTitleColor = () => {
        if (isDimmed) return 'ds.fg.neutral.secondary' as const;
        if (tier && tier in tierColorMap) {
            return tierColorMap[tier as keyof typeof tierColorMap];
        }
        if (isPopular) return 'ds.fg.accent2.primary' as const;
        return 'ds.fg.accent1.primary' as const;
    };

    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
        >
            <Typography
                variant="h6"
                fontWeight="semibold"
                color={getTitleColor()}
            >
                {children}
            </Typography>
            {isPopular && (
                <Chip size="xxs" colorScheme="accent2">
                    Popular
                </Chip>
            )}
        </Stack>
    );
};
